export default "__VITE_ASSET__DU1M6G9q__"